var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.session.gauge)?_c('span',[_vm._v("\n    il reste "+_vm._s(_vm.session.gauge)+" place(s)\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }